import { mapState } from 'vuex'
// api
import ModelService from '@/services/model.service'

export default {
  name: 'Factory',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [35, 36, 55, 71, 88],
      pageIdList: [87, 63, 162, 164, 166],
      pageIdListTwo: [88, 64, 163, 165, 167],
      CurLanguageIndex: 0,
      // data
      swiperSlides: '',
      pageInfo: '',
      pageInfoTwo: '',
      factoryPopupStatus: false,
      curType: '',
      galleryParams: [
        {
          param: {
            factoryName: 'EVN'
          },
          query: {
            sid: 22,
            tid: 27,
          },
          green: {
            sid: 22,
            tid: 28,
          },
        },
        {
          param: {
            factoryName: 'EVH'
          },
          query: {
            sid: 31,
            tid: 36,
          },
          green: {
            sid: 31,
            tid: 37,
          },
        },
        {
          param: {
            factoryName: 'EVM'
          },
          query: {
            sid: 40,
            tid: 45,
          },
          green: {
            sid: 40,
            tid: 46,
          },
        },
        {
          param: {
            factoryName: 'EVC'
          },
          query: {
            sid: 49,
            tid: 54,
          },
          green: {
            sid: 49,
            tid: 55,
          },
        },
        {
          param: {
            factoryName: 'PRB'
          },
          query: {
            sid: 58,
            tid: 63,
          },
          green: {
            sid: 58,
            tid: 64,
          },
        },
        {
          param: {
            factoryName: 'PBB'
          },
          query: {
            sid: 67,
            tid: 72,
          },
          green: {
            sid: 67,
            tid: 73,
          },
        },
      ],
      pageName: '',
      pageName_cn: {
        more: '查看更多',
      },
      pageName_en: {
        more: 'see more',
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex', 'factoryList'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getPagePic();
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    // 获取页面标题图片
    getPagePic() {
      // lang=EN&module=ourpark&type=2
      const language = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(language).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
          this.getPagePicTwo();
        }
      });
    },
    // 获取页面标题图片
    getPagePicTwo() {
      // lang=EN&module=ourpark&type=2
      const language = {
        id: this.pageIdListTwo[this.LangIndex],
      };
      ModelService.getPageInfo(language).then((res) => {
        if (res.code === 0) {
          this.pageInfoTwo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex]
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 打开工厂列表弹层
    switchFactoryPopup(target) {
      this.curType = target || '';
      this.factoryPopupStatus = !this.factoryPopupStatus;
    },
    // 数据过滤
    even(numbers, target) {
      return numbers.filter( (number) => {
        return number.param.factoryName === target
      })
    },
    // 跳转对应相册
    goGalleryPage(name) {
      const urls = this.even(this.galleryParams, name)[0];
      this.$tools.go({
        name: 'Gallery',
        params: urls.param,
        query: urls[this.curType],
      });
    },
  },
};
